"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merge = void 0;
var isObject = function (item) {
  return item !== null && typeof item === 'object';
};
var isMergebleObject = function (item) {
  return isObject(item) && !Array.isArray(item);
};
var merge = function (target) {
  var sources = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (source === undefined) {
    return target;
  }
  if (isMergebleObject(target) && isMergebleObject(source)) {
    Object.keys(source).forEach(function (key) {
      // @ts-ignore
      if (isMergebleObject(source[key])) {
        // @ts-ignore
        if (!target[key]) {
          // @ts-ignore
          target[key] = {};
        }
        (0, exports.merge)(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }
  return exports.merge.apply(void 0, __spreadArray([target], __read(sources), false));
};
exports.merge = merge;